import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import isMobile from "ismobilejs";
import React, { useEffect } from "react";

const enum fields {
    iframeUrl = "iframeUrl",
    desktopHeight = "desktopHeight",
    mobileHeight = "mobileHeight"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.iframeUrl]: string;
        [fields.desktopHeight]: number;
        [fields.mobileHeight]: number;
    };
}

type Props = WidgetProps & OwnProps;  

const IframeWidget: React.FC<Props> = ({ fields }) => {
    const [frameHeight, setFrameHeight] = React.useState(fields.desktopHeight);
    useEffect(() => {
        if (isMobile().any) {
            setFrameHeight(fields.mobileHeight);            
        }
    }, []);

    return (
        <StyledWrapper>
            <iframe src={fields.iframeUrl} 
            width="100%" 
            height={frameHeight}
            frameBorder="0" 
            style={{border: 0, backgroundColor: "transparent"}}
            ></iframe>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: IframeWidget,
    definition: {
        displayName: "Iframe Container",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.iframeUrl,
                displayName: "Iframe URL",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.desktopHeight,
                displayName: "Desktop Height",
                editorTemplate: "IntegerField",
                fieldType: "General",
                defaultValue: 500,
                isRequired: true,
            },
            {
                name: fields.mobileHeight,
                displayName: "Mobile Height",
                editorTemplate: "IntegerField",
                fieldType: "General",
                defaultValue: 850,
                isRequired: true,
            }
        ],
    },
};

export default widgetModule;
